import { render, staticRenderFns } from "./SetupCost.vue?vue&type=template&id=ef5ffdfe&scoped=true&"
import script from "./SetupCost.vue?vue&type=script&lang=js&"
export * from "./SetupCost.vue?vue&type=script&lang=js&"
import style0 from "./SetupCost.vue?vue&type=style&index=0&id=ef5ffdfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5ffdfe",
  null
  
)

export default component.exports